import { render, staticRenderFns } from "./wordpressMarcas.vue?vue&type=template&id=0d83e479&scoped=true&"
import script from "./wordpressMarcas.vue?vue&type=script&lang=js&"
export * from "./wordpressMarcas.vue?vue&type=script&lang=js&"
import style0 from "./wordpressMarcas.vue?vue&type=style&index=0&id=0d83e479&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d83e479",
  null
  
)

export default component.exports